<template>
  <div class="container">
    <Title></Title>
    <div class="box">
      <!-- 广告位 -->
      <advertisement />
      <!-- 选择器 -->
      <van-field readonly clickable label="按地区选择" :value="value" placeholder="选择城市" @click="showPicker = true" />
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker show-toolbar title="地区选择" :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
      </van-popup>
      <div class="court">
        <div>法院名称</div>
        <div>开通状态</div>
      </div>
      <!-- 列表 -->
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
        <van-cell v-for="(item, index) in list" :key="index" :title="item.fullName"
          :value="item.isOpened == 1 ? '已开通' : '未开通'" :url="'http://tiaojie.court.gov.cn/court/' + item.code" />
      </van-list>
    </div>
  </div>
</template>
<script>
import Title from '../components/title.vue'
import axios from 'axios';
export default {
  components: {
    Title,
  },
  data() {
    return {
      value: '',
      showPicker: false,
      columns: [
        "北京", "天津", "河北", "山西", "内蒙古", "辽宁", "吉林", "黑龙江", "上海", "江苏", "浙江", "安徽", "福建", "江西", "山东", " 河南", "湖北", "湖南", "广东", '广西', '海南',
        "重庆", "四川", "贵州", "云南", "西藏", "陕西", "甘肃", "青海", "宁夏", "新疆兵团"],
      ids: [{
        placename: "北京",
        id: 110000,
      },
      {
        placename: "天津",
        id: 120000,
      },
      {
        placename: "河北",
        id: 130000,
      },
      {
        placename: "山西",
        id: 140000,
      },
      {
        placename: "内蒙古",
        id: 150000,
      },
      {
        placename: "辽宁",
        id: 210000,
      },
      {
        placename: "吉林",
        id: 220000,
      },
      {
        placename: "黑龙江",
        id: 230000,
      },

      {
        placename: "上海",
        id: 310000,
      }, {
        placename: "江苏",
        id: 320000,
      },
      {
        placename: "浙江",
        id: 330000,
      },
      {
        placename: "安徽",
        id: 340000,
      },
      {
        placename: "福建",
        id: 350000,
      },
      {
        placename: "江西",
        id: 360000,
      },
      {
        placename: "山东",
        id: 370000,
      },
      {
        placename: "河南",
        id: 410000,
      },
      {
        placename: "湖北",
        id: 420000,
      },
      {
        placename: "湖南",
        id: 430000,
      },
      {
        placename: "广东",
        id: 440000,
      },
      {
        placename: "广西",
        id: 450000,
      },
      {
        placename: "海南",
        id: 460000,
      },
      {
        placename: "重庆",
        id: 500000,
      },
      {
        placename: "四川",
        id: 510000,
      },
      {
        placename: "贵州",
        id: 520000,
      },
      {
        placename: "云南",
        id: 530000,
      },
      {
        placename: "西藏",
        id: 540000,
      },
      {
        placename: "陕西",
        id: 610000,
      },
      {
        placename: "甘肃",
        id: 620000,
      },
      {
        placename: "青海",
        id: 630000,
      },
      {
        placename: "宁夏",
        id: 640000,
      },
      {
        placename: "新疆",
        id: 650000,
      },
      {
        placename: "新疆兵团",
        id: 6650000,
      },
      ],
      list: [],
      loading: false,
      finished: false,
      id: "",
      city: ''
    }

  },
  created() {
    // 获取当前城市
    axios.get('https://api.vvhan.com/api/getIpInfo').then(res => {
      this.value = res.data.info.city
      this.id = res.data.info.postcode
      this.onLoad()
    })
  },
  methods: {
    // 选择城市
    onConfirm(value, index) {
      this.id = this.ids[index].id
      this.value = value;
      this.showPicker = false;
      this.onLoad()
    },
    // 获取数据
    onLoad() {
      this.finished = false;
      axios.post('/api/apply/agent', { areaCode: this.id }).then(res => {
        if (res.data.code == -1) {
          console.log(res.data);
        } else {
          this.finished = true;
          let data = JSON.parse(res.data)
          this.list = data.data.courtList
        }
      }).catch(err => {
        console.log(err);
      })
    },
  },
}
</script>

<style scoped>
.box {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 4rem 1rem;
}

p {
  width: 100%;
  height: 13.5rem;
  border-radius: 0.5rem;
  margin-top: 2.375rem;
  position: relative;
}

.court {
  display: flex;
  justify-content: space-between;
  padding: 20px 1rem;
  border: 1px solid #9eacb965;
}
</style>



// WEBPACK FOOTER //
// src/page/navigation.vue